import React from "react";
import Cards from "../Components/ServiceCards";
import { ReactTitle } from "react-meta-tags";
import services from "../Components/timelineElements";
import { motion } from "framer-motion";
import Slide from "react-reveal/Slide";

const containerVariants = {
  exit: {
    x: "-100vw",
    transition: {
      ease: "easeInOut",
      duration: 0.5,
    },
  },
};
const cardHover = {
  rotate: "180deg",
};
const Service = () => {
  return (
    // <div>

    <motion.div
      className="row my-5 p-lg-3 pt-1 pt-md-1 p-md-2 w-100"
      variants={containerVariants}
      initial="visible"
      animate="hidden"
      exit="exit"
      id="services"
    >
      <Slide bottom>
        <ReactTitle title="Vibgyor Advisors - Services" />
        <h1
          className="text-center text-uppercase text-warning pt-1 pt-md-1  w-75 "
          style={{
            display: "block",
            borderBottom: "1px solid red",
            width: "50%",
            margin: "0 auto",
          }}
        >
          Our Services
        </h1>

        <div className="row d-flex card-section flex-md-row flex-sm-column  text-center mt-4 mx-auto mx-md-1 m mb-4 justify-content-center">
          {services.map((item) => (
            <Cards
              title={item.title}
              image={item.image}
              desc={item.description}
            />
          ))}
        </div>
      </Slide>
    </motion.div>
    // </div>
  );
};

export default Service;
